import Vue from 'vue';

/**
 * 初始化埋点
 * @param { Vue } vue - Vue 实例
 * @returns { void }
 */
export async function install(vue) {
  require('./setup').install(vue);
}

export default {
  install
};
